var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 668 1422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.801 107.163L332.683 95.5885C407.422 22.7864 511.859 -10.9579 615.067 4.34875C797.748 31.4421 923.877 201.498 896.783 384.179L787.583 1120.48C773.285 1216.89 719.756 1303.09 639.684 1358.66C551.71 1419.71 440.775 1437.53 338.11 1407.08L213.801 1370.22C119.401 1342.23 45.2603 1268.87 16.2662 1174.77L13.14 1164.63C-22.7821 1048.04 20.9859 921.627 121.303 852.214C209.987 790.851 255.5 683.973 238.28 577.512L214.33 429.436C195.187 311.08 234.918 190.821 320.801 107.163Z",
    fill: "url(#paint0_linear_13_446)",
    fillOpacity: 0.95,
    stroke: "#E6E6E6",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_446",
    x1: 526.428,
    y1: -8.79724,
    x2: 313.412,
    y2: 1427.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5667EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B234A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/Point.aba6ab5361985ad8531ba7665dbb8c61.svg";
export { ForwardRef as ReactComponent };